import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import Select from 'react-select';
import ReactQuill from 'react-quill';
import _ from 'lodash';

import 'react-quill/dist/quill.snow.css';

import config from '../../lib/config';
import { settings } from '../../lib/settings';

class Feedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: null,
      feedback: '',
    };
    this.user = settings.get('user');
    const children = [];
    _.each(config.menuItems, (m) => {
      _.each(m.children, (c) => {
        children.push({
          ...c,
          parentTitle: m.title,
          parentType: m.type,
        });
      });
    });
    this.menuItems = this.user ? _.filter(children, c => !c.roles || c.roles.includes(this.user.role)) : [];
    this.options = _.map(this.menuItems, m => ({
      label: `${m.title} ${m.parentTitle}`,
      value: `${m.parentType}/${m.type}`,
    }));
  }

  toggleFeedback() {
    this.setState({ open: !this.state.open });
  }

  sendFeedback() {
    // @TODO
    this.toggleFeedback();
  }

  render() {
    const { open, selected, feedback } = this.state;
    const { payload } = this.props;
    const pageSelected = `${payload.toplevel}/${payload.secondlevel}`;

    let defaultValue;
    if (selected) {
      defaultValue = _.find(this.options, o => o.value === selected);
    } else {
      defaultValue = _.find(this.options, o => o.value === pageSelected);
    }

    return (
      <div className='feedback'>
        {open ?
          <React.Fragment>
            <div className='feedback-modal'>
              <i
                role='button'
                tabIndex={-1}
                className='close fas fa-times'
                onClick={this.toggleFeedback.bind(this)}
              />
              <h5>Leave Feedback for Selected Page</h5>
              <Select
                options={this.options}
                defaultValue={defaultValue}
                onChange={(value) => { this.setState({ selected: value.value }); }}
              />
              <h5 style={{ marginTop: '32px' }}>Comments</h5>
              <ReactQuill
                value={feedback}
                placeholder='Your feedback...'
                style={{
                  width: '100%',
                  backgroundColor: '#FFF',
                }}
                onChange={(value) => { this.setState({ feedback: value }); }}
              />
              <Button
                bsStyle='primary'
                style={{ marginTop: '16px' }}
                onClick={this.sendFeedback.bind(this)}
              >
                Send
              </Button>
            </div>
            <div className='feedback-button open'>
              <Button
                bsStyle='primary'
                onClick={this.toggleFeedback.bind(this)}
              >
                <i className='far fa-thumbs-up' /> Leave Feedback
              </Button>
            </div>
          </React.Fragment> :
          <div className='feedback-button'>
            <Button
              bsStyle='primary'
              onClick={this.toggleFeedback.bind(this)}
            >
              <i className='far fa-thumbs-up' /> Leave Feedback
            </Button>
          </div>
        }
      </div>
    );
  }
}

Feedback.propTypes = {
  payload: PropTypes.shape({}),
};

Feedback.defaultProps = {
  payload: {},
};

export default Feedback;



// WEBPACK FOOTER //
// ./src/views/Components/Feedback.js